define([
    "../transitionsModule",
    "img!../../images/intime.png",
    "img!../../images/warning.png",
    "img!../../images/late.png",
    "json!../../tdnByEntity.json"
], function (module, intime, warning, late, tdnByEntity) {
    "use strict";

    return module.controller("MonitoringTransitionOverviewController", [
        "$scope",
        "$q",
        "monitoringService",
        "reload",
        "loadingService",
        "transitionService",
        "remoteExceptionHandler",
        "transitionFailureReasonModal",
        "tdnHelp",
        "attachmentMandatoryModal",
        function ($scope, $q, monitoringService, reload, loadingService, transitionService, remoteExceptionHandler, transitionFailureReasonModal, tdnHelp, attachmentMandatoryModal) {
            const INVOICE_TYPE = "br.com.neolog.monitoring.monitorable.model.api.StandardMonitorableType.INVOICE";

            $scope.tdn = tdnByEntity?.[tdnHelp.getContext()]?.["transition-overview"];
            $scope.serviceName = monitoringService.getExpectedTransitionsFilterUrl();
            var template = [], paginationApi, paginationApiDefer = $q.defer();
            var filterApi, filterApiDefer = $q.defer();
            var checkedRecord = [];

            $scope.search = function (modifiedTemplate) {
                checkedRecord.length = 0;
                template = modifiedTemplate;
                paginationApi.seekPage(1);
            };

            $scope.onRegisterFilterApi = function (api) {
                filterApi = api;
                filterApiDefer.resolve();
            };

            $scope.getStatusImage = function (delayStatus) {
                if (delayStatus === "br.com.neolog.monitoring.transition.TransitionDelayStatus$DelayStatus.IN_TIME") {
                    return intime;
                }
                if (delayStatus === "br.com.neolog.monitoring.transition.TransitionDelayStatus$DelayStatus.WARNING") {
                    return warning;
                }
                return late;
            };

            $scope.tableOptions = {
                records: [],
                pagination: {
                    onPaginate: function (firstResult, maxResults) {
                        return loadingService(monitoringService.filterExpectedTransitions(template, firstResult, maxResults))
                            .then(function (result) {
                                return result;
                            }).catch(remoteExceptionHandler());
                    }
                },
                onRegisterPagination: function (api) {
                    paginationApi = api;
                    paginationApiDefer.resolve();
                }
            };

            $scope.isRecordChecked = function (record) {
                return checkedRecord.indexOf(record) !== -1;
            };

            $scope.toggleCheck = function (record) {
                if (!$scope.isRecordChecked(record)) {
                    checkedRecord.push(record);
                } else {
                    checkedRecord.splice(checkedRecord.indexOf(record), 1);
                }
            };

            $scope.finalizeTransitions = function () {
                if (checkedRecord.length === 1 && checkedRecord[0].trip.type === INVOICE_TYPE) {
                    return transitionService.isAttachmentRequired().then(function (isAttachmentRequired) {
                        if (isAttachmentRequired) {
                            return attachmentMandatoryModal(checkedRecord[0].transition.id)
                                .then(() => $scope.search(template))
                        }
                        return executeFinalize();
                    })
                }
                return executeFinalize();
            };

            function executeFinalize() {
                return transitionService.accomplishTransitions(checkedRecord.map((record) => record.transition.id))
                    .then(() => $scope.search(template))
            }

            $scope.notAccomplishTransitions = function () {
                if ($scope.hasMoreThanOneInvoiceSelected()) {
                    return;
                }
                let transitionIds = checkedRecord.map((record) => record.transition.id)
                let invoiceRecord = checkedRecord.find((record) => record.trip.type === INVOICE_TYPE);
                if (!invoiceRecord) {
                    return transitionService.notAccomplishTransitions(transitionIds)
                        .then(() => $scope.search(template))
                }
                return transitionFailureReasonModal(transitionIds, Date.now(), invoiceRecord.trip)
                    .then((restRemoteMessage) => {
                        if (restRemoteMessage) {
                            return $scope.search(template)
                        }
                    })
            };

            $scope.hasRecordSelection = function () {
                return checkedRecord.length;
            };

            $scope.hasMoreThanOneInvoiceSelected = function () {
                let invoiceQuantity = checkedRecord.filter(record => record.trip.type === INVOICE_TYPE).length;
                return invoiceQuantity > 1
            };

        }]);
});
